import { render } from "./WidgetPage.vue?vue&type=template&id=7282c744"
import script from "./WidgetPage.vue?vue&type=script&lang=js"
export * from "./WidgetPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__